@for (field of fields(); track fieldTrackBy($index, field)) {
  @switch (field.type) {
    @case ("address") {
      <div class="form-group flex column gap-8">
        <app-address-smart-input
          [label]="field.label"
          [placeholder]="
            field.placeholder || 'Enter wallet address or KNS domain'
          "
          [isFullWidth]="true"
          [isValid]="true"
          [invalidReason]="''"
          [isDisabled]="isDisabled()"
          [value]="addressValue()"
          (valueChange)="addressChange.emit($event)"
          (resolved)="addressResolved.emit($event)"
          (qrClick)="addressQrClick.emit()"
        ></app-address-smart-input>
        @if (field.description) {
          <span class="text-gray-60 typo-text-2">{{ field.description }}</span>
        }
      </div>
    }
    @case ("amount") {
      <div class="form-group flex column gap-8">
        <kc-number-input
          [label]="field.label"
          [placeholder]="'0'"
          [min]="field.min || '0'"
          [isDisabled]="isDisabled()"
          [ngModel]="amountValue()"
          (valueChange)="amountChange.emit($event)"
        >
          @if (field.allowMax) {
            <div
              (click)="!isDisabled() && amountMaxClick.emit()"
              [class]="
                isDisabled() ? 'max-text disabled' : 'max-text clickable'
              "
              rightSideSlot
            >
              <span>Max</span>
            </div>
          }
        </kc-number-input>
        @if (field.description) {
          <span class="text-gray-60 typo-text-2">{{ field.description }}</span>
        }
      </div>
    }
    @case ("timestamp") {
      <div class="form-group flex column gap-8">
        <app-covenant-date-time-input
          [label]="field.label"
          [value]="timestampValue()"
          [isDisabled]="isDisabled()"
          [isValid]="true"
          (valueChange)="timestampChange.emit($event)"
        ></app-covenant-date-time-input>
        @if (timestampWarning()) {
          <span class="field-warning">{{ timestampWarning() }}</span>
        }
        @if (field.description) {
          <span class="text-gray-60 typo-text-2">{{ field.description }}</span>
        }
      </div>
    }
    @case ("extra-int") {
      <div class="form-group flex column gap-8">
        <kc-number-input
          [label]="field.label"
          [placeholder]="'Enter ' + field.paramName + ' value'"
          [isDisabled]="isDisabled()"
          [ngModel]="extraArgValues()[field.paramName] || ''"
          (valueChange)="
            extraArgChange.emit({ name: field.paramName, value: $event })
          "
        ></kc-number-input>
        @if (field.description) {
          <span class="text-gray-60 typo-text-2">{{ field.description }}</span>
        }
      </div>
    }
    @case ("extra-bool") {
      <div class="form-group flex column gap-8">
        <kc-number-input
          [label]="field.label"
          [placeholder]="'Enter ' + field.paramName + ' value (0 or 1)'"
          [isDisabled]="isDisabled()"
          [ngModel]="extraArgValues()[field.paramName] || ''"
          (valueChange)="
            extraArgChange.emit({ name: field.paramName, value: $event })
          "
        ></kc-number-input>
        @if (field.description) {
          <span class="text-gray-60 typo-text-2">{{ field.description }}</span>
        }
      </div>
    }
    @case ("banner") {
      <div
        class="p-12 rounded-lg"
        [style]="
          field.tone === 'warning'
            ? 'background: rgba(255, 193, 7, 0.08); border: 1px solid rgba(255, 193, 7, 0.2);'
            : 'background: rgba(111, 199, 186, 0.08); border: 1px solid rgba(111, 199, 186, 0.2);'
        "
      >
        <span
          [class]="
            field.tone === 'warning'
              ? 'text-yellow typo-text-2'
              : 'text-gray-75 typo-text-2'
          "
          >{{ field.text }}</span
        >
      </div>
    }
  }
}
